import React from 'react'
import type { ReactNode } from 'react'

import styles from './styles.module.css'

interface IRoomConfiguratorHeaderProps {
  children: ReactNode
}

function RoomConfiguratorHeader({ children }: Readonly<IRoomConfiguratorHeaderProps>) {
  if (!children) return null

  return <header className={styles.header}>{children}</header>
}

RoomConfiguratorHeader.displayName = 'RoomConfigurator.Header'
export default RoomConfiguratorHeader
